import React, { useRef } from 'react';
import { motion, useMotionValue, useSpring, useTransform, useScroll } from 'framer-motion';

export const TiltPortrait = ({ src, alt, badge, testId, position = "object-top" }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [8, -8]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-10, 10]), { stiffness: 120, damping: 18 });
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const scrollRot = useTransform(scrollYProgress, [0, 0.5, 1], [10, 0, -12]);
  const lift = useTransform(scrollYProgress, [0, 1], [40, -60]);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <div ref={ref} className="br-perspective" onMouseMove={onMove} onMouseLeave={reset} data-testid={testId}>
      <motion.div style={{ rotateX: scrollRot, y: lift }} className="br-preserve">
        <motion.div style={{ rotateX: rx, rotateY: ry }} className="br-preserve relative">
          <div className="absolute -inset-6 rounded-[32px] bg-[#4ECDC4]/20 blur-3xl" style={{ transform: 'translateZ(-80px)' }} />
          <div className="relative aspect-[4/5] overflow-hidden rounded-[28px] border border-white/10 shadow-[0_50px_120px_-30px_rgba(0,0,0,0.9)]">
            <img src={src} alt={alt} className={`h-full w-full object-cover ${position}`} />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D10]/70 via-transparent to-transparent" />
          </div>
          {badge && (
            <div className="absolute -left-4 sm:-left-10 bottom-10 rounded-2xl border border-white/10 bg-[#0A0D10]/80 backdrop-blur-xl px-5 py-4 max-w-[240px]" style={{ transform: 'translateZ(70px)' }}>
              {badge}
            </div>
          )}
        </motion.div>
      </motion.div>
    </div>
  );
};
